module.exports = __webpack_public_path__ + "static/hero2-c080b96aaa480084c91f9e021a355ce7.jpg";